import React, { useState, useEffect } from "react";
import './header.scss';
import { Anchor, Dropdown, Popover } from "antd";
import { useTranslation } from 'react-i18next';
import { zipImages } from "../../untils/until";
import i18n from "../../language/i18n";

interface HeaderProps {
    onNavClick: (type: string, ip: number) => void;
    activeTab: string; // 新增activeTab属性
}



const Header: React.FC<HeaderProps> = ({ onNavClick, activeTab }) => {
    const { i18n } = useTranslation();
    const [language, setLanguage] = useState('CN');
    const [showAnchors, setShowAnchors] = useState(false);
    const { t } = useTranslation();

    const [ipList, setIpList] = useState([
            {
                key: 0,
                ip: i18n.t('space_qhc_title'),
                verse: i18n.t('space_qhc_subtitle'),
                subName: i18n.t('detail_qhc_title'),
                verseBg: zipImages("https://oss.tnworld.cn/eastern/assets/qhc/qhc-nav-verse.jpg"),
                ipBg: zipImages("https://oss.tnworld.cn/eastern/assets/qhc/qhc-nav-ip.jpg"),
                coverColor: "rgba(54, 81, 124, 0.75)"


            }, {
                key: 1,
                ip: i18n.t('space_zgj_title'),
                verse: i18n.t('space_zgj_subtitle'),
                subName: i18n.t('detail_zgj_title'),
                verseBg: zipImages("https://oss.tnworld.cn/eastern/assets/zgj/zgj-nav-verse.jpg"),
                ipBg: zipImages("https://oss.tnworld.cn/eastern/assets/zgj/zgj-nav-ip.jpg"),
                coverColor: "rgba(128, 22, 27, 0.75)"

            }, {
                key: 2,
                ip: i18n.t('space_qhc_title'),
                verse: i18n.t('space_cjy_subtitle'),
                subName: i18n.t('detail_cjy_title'),
                verseBg: zipImages("https://oss.tnworld.cn/eastern/assets/cjy/cjy-nav-verse.jpg"),
                ipBg: zipImages("https://oss.tnworld.cn/eastern/assets/cjy/cjy-nav-ip.jpg"),
                coverColor: "rgba(200, 145, 78, 0.75)"
            }, {
                key: 3,
                ip: i18n.t('space_jtl_title'),
                verse: i18n.t('space_jtl_subtitle'),
                subName: i18n.t('detail_jtl_title'),
                verseBg: zipImages("https://oss.tnworld.cn/eastern/assets/jtl/jtl-nav-verse.jpg"),
                ipBg: zipImages("https://oss.tnworld.cn/eastern/assets/jtl/jtl-nav-ip.jpg"),
                coverColor: "rgba(19, 102, 170, 0.75)",

            }
        ]);



    const updateIpList = () => {
        setIpList([
            {
                key: 0,
                ip: i18n.t('space_qhc_title'),
                verse: i18n.t('space_qhc_subtitle'),
                subName: i18n.t('detail_qhc_title'),
                verseBg: zipImages("https://oss.tnworld.cn/eastern/assets/qhc/qhc-nav-verse.jpg"),
                ipBg: zipImages("https://oss.tnworld.cn/eastern/assets/qhc/qhc-nav-ip.jpg"),
                coverColor: "rgba(54, 81, 124, 0.75)"


            }, {
                key: 1,
                ip: i18n.t('space_zgj_title'),
                verse: i18n.t('space_zgj_subtitle'),
                subName: i18n.t('detail_zgj_title'),
                verseBg: zipImages("https://oss.tnworld.cn/eastern/assets/zgj/zgj-nav-verse.jpg"),
                ipBg: zipImages("https://oss.tnworld.cn/eastern/assets/zgj/zgj-nav-ip.jpg"),
                coverColor: "rgba(128, 22, 27, 0.75)"

            }, {
                key: 2,
                ip: i18n.t('space_qhc_title'),
                verse: i18n.t('space_cjy_subtitle'),
                subName: i18n.t('detail_cjy_title'),
                verseBg: zipImages("https://oss.tnworld.cn/eastern/assets/cjy/cjy-nav-verse.jpg"),
                ipBg: zipImages("https://oss.tnworld.cn/eastern/assets/cjy/cjy-nav-ip.jpg"),
                coverColor: "rgba(200, 145, 78, 0.75)"
            }, {
                key: 3,
                ip: i18n.t('space_jtl_title'),
                verse: i18n.t('space_jtl_subtitle'),
                subName: i18n.t('detail_jtl_title'),
                verseBg: zipImages("https://oss.tnworld.cn/eastern/assets/jtl/jtl-nav-verse.jpg"),
                ipBg: zipImages("https://oss.tnworld.cn/eastern/assets/jtl/jtl-nav-ip.jpg"),
                coverColor: "rgba(19, 102, 170, 0.75)",

            }
        ])
    }

    useEffect(() => {
        updateIpList();
    }, [i18n.language]); // 当语言变化时更新 ipList

    useEffect(() => {
        if (localStorage.getItem('language')) {
            changeLanguage(localStorage.getItem('language') ?? '')
        }
    }, [])

    // 修改语言
    const changeLanguage = (lan: string) => {
        setLanguage(lan);
        localStorage.setItem('language', lan);
        if (lan === 'CN') {
            i18n.changeLanguage('ch');
        } else {
            i18n.changeLanguage('en');
        }
    }

    const verseDropDown = (
        <div className="sub-box">
            {
                ipList.map(item => (
                    <div className="sub-item" key={item.key} style={{ backgroundImage: `url(${item.verseBg})` }} onClick={() => { onNavClick("verse", item.key) }}>
                        <div className="sub-item-cover" style={{ background: item.coverColor }}></div>
                        <div className="item-text">
                            <div className="ip-title" style={i18n.language === 'en' ? {
                                fontSize: "0.7rem",
                                width: "90%",
                                textAlign: "center"
                            } : {}}>{item.ip}</div>
                            <div className="verse-name" style={i18n.language === 'en' ? {
                                fontSize: "0.6rem",
                                width: "90%",
                                textAlign: "center"
                            } : {}}>{item.verse}</div>
                        </div>
                        <div className="item-arrow"></div>
                        {/* <a href={`#part-${item}`}>{item}</a> */}
                    </div>
                ))
            }
        </div>
    );

    const ipDropDown = (
        <div className="sub-box">
            {
                ipList.map(item => (
                    <div className="sub-item" key={item.key} style={{ backgroundImage: `url(${item.ipBg})` }} onClick={() => { onNavClick("detail", item.key) }}>
                        <div className="sub-item-cover" style={{ background: item.coverColor }}></div>
                        <div className="item-text">
                            <div className="verse-name" style={i18n.language === 'en' ? {
                                fontSize: "0.8rem",
                                width: "90%",
                                textAlign: "center"
                            } : {}}>{item.subName}</div>
                        </div>
                        <div className="item-arrow"></div>
                        {/* <a href={`#part-${item}`}>{item}</a> */}
                    </div>
                ))
            }
        </div>
    );

    // 下拉菜单
    const items = [
        {
            key: '1',
            label: (
                <div onClick={() => changeLanguage('CN')}>
                    CN
                </div>
            ),
        },
        {
            key: '2',
            label: (
                <div onClick={() => changeLanguage('EN')}>
                    EN
                </div>
            ),
        },
    ];

    const getCurrentAnchor = () => {
        return 'part-2'
    }

    return (
        <header className="navbar">
            <div className="navbar-border">
                <div className="navbar-logo">
                    <img src={zipImages("https://oss.tnworld.cn/eastern/assets/logo1.png")} style={{ filter: 'invert(0)' }} alt="" />
                </div>
                <nav className="navbar-nav">
                    <div className="navbar-item" onClick={() => { onNavClick("home", -1) }}>{t('home_home')}</div>
                    <Popover
                        placement="bottom"
                        trigger={['hover']}
                        content={verseDropDown}
                        color="linear-gradient(180deg, rgba(255, 255, 255, 0.80) 0%, rgba(255, 255, 255, 0.16) 100%)"
                        overlayInnerStyle={{ padding: 8, borderRadius: '2px', background: 'linear-gradient(180deg, rgba(255, 255, 255, 0.80) 0%, rgba(255, 255, 255, 0.16) 100%)' }}
                    >
                        <div className="navbar-item" onClick={() => { onNavClick("verse", -1) }}>{t('home_metaverse')}</div>
                    </Popover>

                    <Popover
                        placement="bottom"
                        trigger={['hover']}
                        content={ipDropDown}
                        color="linear-gradient(180deg, rgba(255, 255, 255, 0.80) 0%, rgba(255, 255, 255, 0.16) 100%)"
                        overlayInnerStyle={{ padding: 8, borderRadius: '2px', background: 'linear-gradient(180deg, rgba(255, 255, 255, 0.80) 0%, rgba(255, 255, 255, 0.16) 100%)' }}
                    >
                        <div className="navbar-item" onClick={() => { onNavClick("detail", -1) }}>{t('home_ip')}</div>
                    </Popover>

                    <div className="navbar-item" onClick={() => { onNavClick("about", -1) }}>{t('home_about')}</div>


                </nav>
                <div className="navbar-lang">
                    <Dropdown
                        trigger={['click']}
                        menu={{
                            items,
                        }}
                        placement="bottom"
                        arrow
                    >
                        <div>{language}</div>
                    </Dropdown>
                    <img className="menu" src="/assets/images/menu-line.png" alt="" onClick={() => setShowAnchors(!showAnchors)} />
                    <div className={`${showAnchors ? "anchors-box" : "close-anchors-box"}`}>
                        <Anchor

                            affix={false}
                            items={[
                                { key: 'part-1', href: '#part-1', title: 'Home' },
                                { key: 'part-2', href: '#part-2', title: 'Metaverse' },
                                { key: 'part-3', href: '#part-3', title: 'NFT Launchpad' },
                                { key: 'part-4', href: '#part-4', title: 'About us' }
                            ]}
                            getCurrentAnchor={getCurrentAnchor}
                            onClick={(e) => {
                                e.preventDefault();
                                const target = e.target as HTMLAnchorElement;
                                const href = target.getAttribute('href');
                                if (href) {
                                    const id = href.substring(1);
                                    // onNavClick(id);
                                }
                            }}
                        />
                    </div>
                </div>
            </div>
        </header>
    )
}

export default Header;
